import { Component } from "@theme/component";

class MainNavigationModal extends Component {
  connectedCallback() {
    document.addEventListener('menuButton:click', () => {
      this.showModal();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('menuButton:click', () => {
      this.showModal();
    });
  }

  #previousScrollY = 0;

  showModal() {
    const scrollY = window.scrollY;
    this.#previousScrollY = scrollY;

    // Prevent layout thrashing by separating DOM reads from DOM writes
    requestAnimationFrame(() => {
      this.setAttribute('open', 'true');
      document.body.style.width = "100%";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
    });
  }

  closeModal() {
    this.removeAttribute('open');
    document.body.style.width = "";
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo({ top: this.#previousScrollY, behavior: "instant" });

    const navigationPanel = this.querySelector('navigation-panel');
    console.log(navigationPanel);
  }
}

if (!customElements.get("main-navigation-modal")) {
  customElements.define("main-navigation-modal", MainNavigationModal);
}
